import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installment-due',
  templateUrl: './installment-due.component.html',
  styleUrls: ['./installment-due.component.css']
})
export class InstallmentDueComponent implements OnInit {
  title="Generate List";
  title1="Print Letter"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/installment-due/installment-due.component.ts